import ReferralIndex from "../../pages/dashboard/referral";
import CreateCampaign from "../../pages/dashboard/referral/CreateCampaign";
import EditCampaign from "../../pages/dashboard/referral/EditCampaign";
import PromotionDetails from "../../pages/dashboard/referral/PromotionDetails";
import InfluencerApplication from "../../pages/dashboard/referral/InfluencerApplication";
import { ALL_ROUTES } from "../AllRoutes";

export const referral_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_REFERRAL,
    element: ReferralIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_REFERRAL_CREATE_CAMPAIGN,
    element: CreateCampaign,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_REFERRAL_EDIT_CAMPAIGN,
    element: EditCampaign,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_REFERRAL_VIEW_CAMPAIGN,
    element: PromotionDetails,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_REFERRAL_INFLUENCER_APPLICATION,
    element: InfluencerApplication,
  },
];
